import React from 'react'
import { Row, Col, Table, Tag, Space, Image } from 'antd';
import { connect } from 'react-redux'
import { withRouter } from "react-router-dom";
import _ from 'lodash'
import './index.less'
import List from './list'
import CategoryEdit from '../edit/components/CategoryEdit';
import CategoryTree from '@/components/CategoryTree'

@withRouter
@connect(
  state => ({
    categories: state.categories
  })
)
class AdminHome extends React.Component {
  constructor (props) {
    super(props)

    this.ListCom = React.createRef() // 此处初始化

    this.state = {
      selectedCategories: []
    }
  }

  categoryChange = (selectedCategories) => {
    this.setState({
      selectedCategories: selectedCategories[0] !== this.state.selectedCategories[0] ? selectedCategories : []},
      this.ListCom.current.init
    )
  }

  componentDidMount () {
    console.log('this.ListCom', this.ListCom)
  }

  render () {
    const { categoryChange, state } = this
    const { selectedCategories } = state
    console.log('this.props.categories', this.props.categories)
    return (
      <div>
        <Row gutter={18}>
          <Col span={6}>
            <CategoryTree tree={this.props.categories} />
            {/* <CategoryEdit multi={false} selectedArr={selectedCategories} onChange={categoryChange} /> */}
          </Col>
          <Col span={18}>
            <List
              wrappedComponentRef={this.ListCom}
              selectedCategories={selectedCategories}
            />
          </Col>
        </Row>
      </div>
    )
  }
}

export default AdminHome
